import React, { useState, useRef } from 'react';
import { Checkbox } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { IReviewNote } from 'interfaces/review/IReviewDataRow';
import { ReactComponent as DownIcon } from '../../../../../components/icons/down.svg';
import { Control, ExpandIconWrapper, Note, NoteCellWrapper, Text } from './NoteCellStyles';

export interface IProps {
  data: IReviewNote;
  onResolvedChanged: (newVal: IReviewNote) => void;
}

const NoteCell: React.FC<IProps> = observer(({ data, onResolvedChanged }) => {
  const [expandNote, setExpandNote] = useState<boolean>(false);
  const [isListBelowBottom, setIsListBelowBottom] = useState<boolean>(false);
  const wrapperRef = useRef<any>();
  useOnClickOutside(
    wrapperRef,
    () => {
      setExpandNote(false);
    },
    'click'
  );

  const handleOnClick = () => {
    setExpandNote(!expandNote);
  };

  return (
    <NoteCellWrapper>
      {data.note && (
        <>
          <Note>{data.note}</Note>
          <div ref={wrapperRef}>
            <ExpandIconWrapper className={`expand-icon${expandNote ? ' expanded' : ''}`}>
              <DownIcon onClick={handleOnClick} />
            </ExpandIconWrapper>
            <SelectList
              visible={expandNote}
              isBelowBottomCallback={(isBelow: boolean) => setIsListBelowBottom(isBelow)}
              top={isListBelowBottom ? 'auto' : '50px'}
              bottom={isListBelowBottom ? '50px' : 'auto'}
            >
              <div>
                <Text>{data.note}</Text>
                <Control>
                  <Checkbox
                    label=''
                    checked={data.isResolved}
                    onChange={(event: any) =>
                      onResolvedChanged({
                        note: data.note,
                        isResolved: event.target.checked,
                      })
                    }
                  />
                  Resolve
                </Control>
              </div>
            </SelectList>
          </div>
        </>
      )}
    </NoteCellWrapper>
  );
});

export default NoteCell;
